import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logos/logo3.png'


const _hoisted_1 = { class: "content d-flex justify-content-center align-items-center" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body p-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-3 mx-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    border: "0",
    alt: "",
    class: "img-fluid"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted text-center mb-3" }, " Bitte bestätigen Sie Ihre Emailadresse und setzen Sie ein Passwort für Ihren Login ", -1)
const _hoisted_7 = { class: "form-group form-group-feedback form-group-feedback-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "form-control-feedback" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-user text-muted" })
], -1)
const _hoisted_9 = { class: "form-group form-group-feedback form-group-feedback-left" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = ["type"]
const _hoisted_12 = { class: "input-group-append" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "form-control-feedback" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-user text-muted" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { class: "form-group form-group-feedback form-group-feedback-left" }
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = ["type"]
const _hoisted_18 = { class: "input-group-append" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "form-control-feedback" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-lock2 text-muted" })
], -1)
const _hoisted_20 = { class: "form-group form-group-feedback form-group-feedback-left" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = ["type"]
const _hoisted_23 = { class: "input-group-append" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "form-control-feedback" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-lock2 text-muted" })
], -1)
const _hoisted_25 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              type: "text",
              tabindex: "1",
              placeholder: "Emailadresse",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frm.username.value) = $event))
            }, null, 512), [
              [_vModelText, _ctx.frm.username.value]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.frm.pin.protected?'password':'text',
                tabindex: "2",
                placeholder: "Start-Pin",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.frm.pin.value) = $event))
              }, null, 8, _hoisted_11), [
                [_vModelDynamic, _ctx.frm.pin.value]
              ]),
              _createElementVNode("span", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.frm.pin.protected=!_ctx.frm.pin.protected))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fal", _ctx.frm.pin.protected?'fa-eye':'fa-eye-slash'])
                  }, null, 2)
                ])
              ]),
              _hoisted_13
            ])
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.frm.password.protected?'password':'text',
                tabindex: "2",
                placeholder: "Passwort",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.frm.password.value) = $event))
              }, null, 8, _hoisted_17), [
                [_vModelDynamic, _ctx.frm.password.value]
              ]),
              _createElementVNode("span", _hoisted_18, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.frm.password.protected=!_ctx.frm.password.protected))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fal", _ctx.frm.password.protected?'fa-eye':'fa-eye-slash'])
                  }, null, 2)
                ])
              ]),
              _hoisted_19
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.frm.confirm_password.protected?'password':'text',
                tabindex: "2",
                placeholder: "Passwort wiederholen",
                class: "form-control",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.frm.confirm_password.value) = $event))
              }, null, 8, _hoisted_22), [
                [_vModelDynamic, _ctx.frm.confirm_password.value]
              ]),
              _createElementVNode("span", _hoisted_23, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.frm.confirm_password.protected=!_ctx.frm.confirm_password.protected))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fal", _ctx.frm.confirm_password.protected?'fa-eye':'fa-eye-slash'])
                  }, null, 2)
                ])
              ]),
              _hoisted_24
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-lg btn-block",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args))),
              tabindex: "3"
            }, "Login")
          ])
        ])
      ])
    ])
  ]))
}